const VIEW_AS_ADMIN_KEY = "view-as-admin";

export const isAdmin = () => localStorage.getItem("admin-token") !== null;

export const isViewAsAdmin = () =>
  isAdmin() && localStorage.getItem(VIEW_AS_ADMIN_KEY) === "true";

export const setViewAsAdmin = (viewAsAdmin: boolean) => {
  if (viewAsAdmin) {
    localStorage.setItem(VIEW_AS_ADMIN_KEY, "true");
  } else {
    localStorage.removeItem(VIEW_AS_ADMIN_KEY);
  }
};
